// store/contentSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OnboardData } from "../interface/onboard";
import Cookies from "js-cookie";
import config from "../utils/config";
import { DashboardPropsData } from "../interface/dashboard";
import { NotificationMessage } from "../interface/messages";

export interface AccountProfileDataStore {
  id: number;
  name: string;
  image: string;
  kyced: number;
  id_uploaded: number;
}

interface ContentState {
  value: number;
  verification_status: string;
  onboarded: boolean;
  refresh_dashboard: boolean;
  verified: boolean;
  user_onboarded_data: OnboardData;
  account_profile_data: AccountProfileDataStore;
  badge_number: number;
  dashboard_items: DashboardPropsData[];
  dashboard_last_fetched: number | null;
  notification_data: NotificationMessage[];
}

const initialState: ContentState = {
  value: 0,
  verification_status: "not-complete",
  onboarded: false,
  verified: false,
  refresh_dashboard: false,
  user_onboarded_data: {
    name: "",
    dob: null,
    gender: "",
    state_id: "",
    local_government_id: "",
  },
  account_profile_data: {
    id: 0,
    name: "",
    image: "",
    kyced: 0,
    id_uploaded: 0,
  },
  badge_number: 0,
  dashboard_items: [],
  dashboard_last_fetched: Date.now(),
  notification_data: [],
};

const contentSlice = createSlice({
  name: "content",
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    setValue: (state, action: PayloadAction<number>) => {
      state.value = action.payload;
    },

    setVerification_status: (state, action: PayloadAction<string>) => {
      state.verification_status = action.payload;
    },
    setOnboarded: (state, action: PayloadAction<boolean>) => {
      state.onboarded = action.payload;
    },
    setRefresh_dashboard: (state, action: PayloadAction<boolean>) => {
      state.refresh_dashboard = action.payload;
    },

    setBadge_number: (state, action: PayloadAction<number>) => {
      state.badge_number = action.payload;
    },
    setVerified: (state, action: PayloadAction<boolean>) => {
      state.verified = action.payload;
      // Set the cookie using cookie-js
      Cookies.set(config.key.ACCOUNT_VERIFIED, JSON.stringify(action.payload));
    },
    setAccount_profile_data: (
      state,
      action: PayloadAction<{
        id: number;
        name: string;
        image: string;
        kyced: number;
        id_uploaded: number;
      }>
    ) => {
      state.account_profile_data = action.payload;
      Cookies.set(config.key.ACCOUNT_PROFILE, JSON.stringify(action.payload));
    },
    setUser_onboarded_data: (state, action: PayloadAction<OnboardData>) => {
      state.user_onboarded_data = action.payload;
    },
    setDashboard_items: (
      state,
      action: PayloadAction<DashboardPropsData[]>
    ) => {
      state.dashboard_items = action.payload;
    },
    appendDashboard_items: (
      state,
      action: PayloadAction<DashboardPropsData[]>
    ) => {
      state.dashboard_items = [...state.dashboard_items, ...action.payload];
    },
    clearDashboard_items: (state) => {
      state.dashboard_items = [];
    },
    setNotification: (state, action: PayloadAction<NotificationMessage[]>) => {
      // state.notification_data.push(action.payload);
      state.notification_data = action.payload;
    },
  },
});

export const {
  increment,
  decrement,
  setValue,
  setOnboarded,
  setVerified,
  setRefresh_dashboard,
  setVerification_status,
  setUser_onboarded_data,
  setAccount_profile_data,
  setBadge_number,
  setDashboard_items,
  appendDashboard_items,
  clearDashboard_items,
  setNotification,
} = contentSlice.actions;
export default contentSlice.reducer;
